// Considered: No existing atom renders a directional SVG flow connector with gradient coloring and directional arrowhead. See spec Reuse Audit.
import React, { useId } from 'react';
import './ContextFlowConnectorAtom.scss';

export interface ContextFlowConnectorAtomProps {
  direction: 'outwards' | 'inwards';
  'data-testid'?: string;
}

const ContextFlowConnectorAtom: React.FC<ContextFlowConnectorAtomProps> = ({
  direction,
  'data-testid': testId,
}) => {
  const uid = useId();
  const gradId = `cfc-grad-${uid.replaceAll(':', '')}`;
  const out = direction === 'outwards';

  return (
    <div
      className={`context-flow-connector-atom context-flow-connector-atom--${direction}`}
      data-testid={testId}
    >
      <svg
        width="56"
        height="64"
        viewBox="0 0 56 64"
        fill="none"
        className="context-flow-connector-atom__svg"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id={gradId} x1="0" y1="0" x2="56" y2="0" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor={`var(--color-context-${direction}-fade)`} />
            <stop offset="1" stopColor={`var(--color-context-${direction})`} />
          </linearGradient>
        </defs>
        <path
          d={out ? 'M 2 32 Q 28 32 54 32' : 'M 54 32 Q 28 32 2 32'}
          stroke={`url(#${gradId})`}
          strokeWidth="2"
          strokeLinecap="round"
        />
        <polygon
          points={out ? '54,32 47,28 47,36' : '2,32 9,28 9,36'}
          fill={`var(--color-context-${direction})`}
        />
      </svg>
    </div>
  );
};

export default ContextFlowConnectorAtom;
